import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { PERSONAL_MEDIA_FEATURE_KEY } from './constants';
import { reducers } from './main-reducer';
import { PersonalMediaItemsEffects } from './personal-media-items/personal-media-items.effects';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(PERSONAL_MEDIA_FEATURE_KEY, reducers),
    EffectsModule.forFeature([PersonalMediaItemsEffects]),
  ],
})
export class StatePersonalMediaModule {}
